export const SDK_STREAM_TIMEOUT_MS = 3_600_000;
